import { defineStore } from 'pinia'
import { useChatStore } from '@/stores/chat'
import { useUsersStore } from '@/stores/users'
import { useGroupsStore } from '@/stores/groups'
import { orderDateAsc } from '@/helpers/messages'

import { ItemMessageChat, TypeMessage, FavoriteMessage } from '@/types/itemsMessages'
import { ChatItemSelected, ResponseMessageUser } from '@/types/internalChatAxios'
import { SuccessSendMessage } from '@/types/webSocketMessage'
import { RootStateMessage, KeysRootStateMessage } from '@/types/message'

// todo - corrigir metodos com state.users para validar o grupo
export const useMessageStore = defineStore('message', {
    state: (): RootStateMessage => ({
        users: {},
        groups: {}
    }),
    /*
     */
    getters: {

        chat: (state) => {
            const chatStore = useChatStore()
            const type: ChatItemSelected = chatStore.getWith
            if (!chatStore.selected?.id) {
                return []
            }
            if ( type === 'to_group' && state.groups && state.groups[chatStore.selected.id] ) {
                return orderDateAsc(state.groups[chatStore.selected.id].data)
            }
            if ( type === 'to_user' && state.users && state.users[chatStore.selected.id] ) {
                return orderDateAsc(state.users[chatStore.selected.id].data)
            }
            return []
        },
        getByUuid() {
            return (uuid: string) => this.chat.find((el) => el.uuid === uuid)
        },
        getById() {
            return (id: number) => {
                return this.chat.find((el) => el.id === id)
            }
        },
        count() {
            return this.chat.length
        },
        unread() {
            if (this.chat.length > 0) {
                const result = this.chat as ItemMessageChat[]
                return result.filter((el) => !el.read && el.type === 'received')
                    .length
            }
            return 0
        },
        countMessages(state) {
            return (userId: number, key: KeysRootStateMessage = 'users') => {
                if (state[key][userId]) {
                    return state[key][userId].data.length
                }
                return 0
            }
        },
        getLastMessage(state) {
            return (userId: number, key: KeysRootStateMessage = 'users') => {
                if (state[key][userId]) {
                    //const lastIndex = state[key][userId].data.length - 1
                    return state[key][userId].data[0]
                }
                return null
            }
        },
        getLastScrollMessage: (state) => {
            return (id: number, key: KeysRootStateMessage = 'users') => {
                if (state[key][id]) {
                    return state[key][id].data[0] ?? null
                }
                return null
            }
        },
        userExist(state) {
            return (userId: number) =>
                !!Object.prototype.hasOwnProperty.call(state.users, userId)
        },

        getReply(state) {
            return (id: number, key: KeysRootStateMessage = 'users') => {
                if(state[key][id]?.reply){
                    return state[key][id].reply
                }
                return null
            }
        }
    },
    /*
     */
    actions: {
        initialize(users: number[], groups: number[]): void {
            users.forEach((item) => {
                this.users[item] = {
                    data: [],
                    favorite: [],
                    reply: null
                }
            })
            groups.forEach((item) => {
                this.groups[item] = {
                    data: [],
                    favorite: [],
                    reply: null
                }
            })
        },

        addMessages( id: number, payload: ResponseMessageUser, key: KeysRootStateMessage = 'users' ): void {
            if (!id || !payload.data || payload.data.length === 0) return
            for (const message of payload.data) {
                this.addMessage(id, message, 'push', key)
            }
        },

        addMessage( id: number, payload: ItemMessageChat, order: string = 'push',  key: KeysRootStateMessage = 'users' ): void {
            if (!this[key][id]) {
                console.error(`error : key:${key} id:${id}`)
                return
            }
            if (!payload) {
                return
            }
            if (Object.prototype.hasOwnProperty.call(this[key], id)) {
                if (this[key][id].data.length === 0) {
                    this[key][id].data = [payload]
                } else if (
                    !this[key][id].data.find((el) => el.uuid === payload.uuid)
                ) {
                    if (order === 'push') {
                        this[key][id].data.push(payload)
                    } else {
                        this[key][id].data.unshift(payload)
                    }
                } else {
                    // JA POSSUI uma mensagem com o mesmo uuid
                    // console.log('possui o mesmo uuid ' + payload.uuid)
                }
            } else {
                this[key][id].data = [payload]
            }
        },

        read(id: number, type: TypeMessage = 'received', key: KeysRootStateMessage = 'users'): void {
            if (!id) return
            if(key === 'users') {
                const userStore = useUsersStore()
                if (userStore.getById(id)) {
                    this.users[id].data = this.users[id].data.map(
                        (item) => {
                            if (item.type === type) {
                                item.read = true
                            }
                            return item
                        }
                    )
                }
            }
            if( key === 'groups') {
                const groupsStore = useGroupsStore()
                if (groupsStore.getById(id)) {
                    this.groups[id].data = this.groups[id].data.map(
                        (item) => {
                            item.read = true
                            return item
                        }
                    )
                }
            }

        },

/*         readUserMessage(userId: number): void {
            if (!userId) return
            const userStore = useUsersStore()
            if (userStore.getById(userId)) {
                this.users[userId].data = this.users[userId].data.map(
                    (item) => {
                        item.read = true
                        return item
                    }
                )
            }
        }, */
        confirmationUserMessage(user: number): void {
            if (!user) return
            const userStore = useUsersStore()
            if (userStore.getById(user)) {
                const data = this.users[user].data.map((item) => {
                    item.read = true
                    return item
                })
                this.users[user].data = data
            }
        },

        setMessageFavorite( userId: number, messageId: number, status: number | null = null, key: KeysRootStateMessage = 'users'): void {
            const messageIndex = this[key][userId].data.findIndex(item => item.id === messageId )
            if (messageIndex) {
                this[key][userId].data[messageIndex].favorite = status
            }
        },

        addFavorite(payload: FavoriteMessage, id: number, key: KeysRootStateMessage = 'users') {
            if (!payload) {
                console.error(`payload: ${payload}`)
                return
            }
            if (this[key][id].favorite?.length === 0) {
                this[key][id].favorite = [payload]
            } else {
                this[key][id].favorite?.push(payload)
            }
        },

        removeFavorite(messageId: number, userId: number, key: KeysRootStateMessage = 'users'): boolean {
            if(key === 'users') {
                if (!this.userExist(userId)) {
                    console.error(`user id ${userId} not exist`)
                    return false
                }
            }
            const result = this[key][userId].favorite?.filter( el => el.id !== messageId)
            this[key][userId].favorite = result
            return true
        },

        addReply(payload: ItemMessageChat, userId: number, key: KeysRootStateMessage = 'users'): boolean {
            if (!payload) {
                console.error(`payload: ${payload}`)
                return false
            }
            this[key][userId].reply = payload
            return true
        },

        removeReply(id: number, key: KeysRootStateMessage = 'users') {
            if (!id) {
                console.error(`not informed selected id ${id}`)
                return
            }
            this[key][id].reply = null
        },

        addGroup(payload: ItemMessageChat): void {
            if (!payload) return
            const selectId = payload.submitted_by
            if (Object.prototype.hasOwnProperty.call(this.groups, selectId)) {
                this.groups[selectId].data.push(payload)
            } else {
                this.groups[selectId].data = [payload]
            }
        },

        editGroupMessage(payload: SuccessSendMessage): void {
            if (!payload.to_group) return
            const selectId = payload.to_group
            const index = this.groups[selectId].data.findIndex( el => el.uuid === payload.uuid )
            if (payload.uuid && index !== -1) {
                this.groups[selectId].data[index].id = payload.id
            }else{
                if(!payload?.submitted_by) {
                    console.error('message for group submitted_by is required')
                    return
                }
                const userStore = useUsersStore()
                const type = payload.submitted_by === userStore.me.id ? 'sent' : 'received'
                const submitted_by = payload.submitted_by
                const data: ItemMessageChat = {
                    created_at: new Date().toISOString(),
                    message: {
                        content: payload.message,
                        type: payload.type,
                        extra: payload.extra ?? null
                    },
                    read: payload.read,
                    submitted_by,
                    type,
                    uuid: payload.uuid,
                    id: payload.id
                }
                this.groups[selectId].data.push(data)
            }
        },

        editUserMessage(payload: SuccessSendMessage): void {
            if (!payload.to_user) return
            const selectId = payload.to_user
            const index = this.users[selectId].data.findIndex(
                (p) => p.uuid === payload.uuid
            )
            if (payload.uuid && index !== -1) {
                this.users[selectId].data[index].id = payload.id
                this.users[selectId].data[index].read = payload.read
            } else {
                const data: ItemMessageChat = {
                    created_at: new Date().toISOString(),
                    message: {
                        content: payload.message,
                        type: payload.type,
                        extra: payload.extra ?? null
                    },
                    read: payload.read,
                    submitted_by: payload.to_user,
                    type: 'sent',
                    uuid: payload.uuid,
                    id: payload.id
                }
                this.users[selectId].data.push(data)
            }
        },
    }
})
